/**
 * Created by mykurisu on 2017/8/8.
 */
const defaults = {
    url_data: null,
    search_text: '',
    //LIVEROOM
    liveroom_init: false,
    liveroom: null,
    liveroom_list: null,
    //CHANNEL
    channel_init: false,
    channel: null,
    channel_list: null,
    //LECTURE
    lecture_init: false,
    lecture: null,
    lecture_list: null,
    //DETAIIL
    detail_init: false,
    detail: null,
    detail_list: null,
};

export default(state = defaults, action) => {
    switch (action.type) {
        case 'SEARCH_INIT':
            return {...state, url_data: action.payload};
        case 'SEARCH_SEARCH_TEXT':
            return {...state, search_text: action.payload};
        case 'SEARCH_LIVEROOM_INIT':
            return {...state, liveroom: action.payload, liveroom_init: true};
        case 'SEARCH_LIVEROOM_LIST':
            return {...state, liveroom_list: action.payload};
        case 'SEARCH_CHANNEL_INIT':
            return {...state, channel: action.payload, channel_init: true};
        case 'SEARCH_CHANNEL_LIST':
            return {...state, channel_list: action.payload};
        case 'SEARCH_LECTURE_INIT':
            return {...state, lecture: action.payload, lecture_init: true};
        case 'SEARCH_LECTURE_LIST':
            return {...state, lecture_list: action.payload};
        case 'SEARCH_DETAIL_INIT':
            return {...state, detail: action.payload, detail_init: true};
        case 'SEARCH_DETAIL_LIST':
            return {...state, detail_list: action.payload};
        case 'SEARCH_CLEAR':
            return {
                ...state,
                liveroom_init: false,
                liveroom: null,
                liveroom_list: null,
                channel_init: false,
                channel: null,
                channel_list: null,
                lecture_init: false,
                lecture: null,
                lecture_list: null,
            };
        case 'SEARCH_DETAIL_CLEAR':
            return {
                ...state,
                detail_init: false,
                detail: null,
                detail_list: null,
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/search.js